<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div class="project-controls {{ controlsClass }}">
    @if (project.description) {
        <ng-container *windeHasAnyAuthority="userAuthorities.ALL_SIKLU">
            <button
                    (mouseover)="showInfo = true"
                    (focus)="showInfo = true"
                    (mouseleave)="showInfo = false"
                    (blur)="showInfo = false"
                    windeActionIcon
            >
                <sui-svg-icon icon="info" windeOrange/>
            </button>
        </ng-container>
    }

    <winde-ctx-sensitive-help
            [tooltipTextPath]="
            project.engineType === EngineProcessTypeEnum.BOM_CONFIGURATOR ? 'projects.bom_config.btn.view' : 'projects.project.btn.view'
        "
            class="btn--view view-project-button"
    >
        <button [replaceUrl]="true" [routerLink]="['/project-view', project.id]" windeActionIcon>
            <sui-svg-icon icon="eye-open" windeOrange/>
        </button>
    </winde-ctx-sensitive-help>

    <ng-container *windeHasAnyAuthority="userAuthorities.PROJECT_EDIT">
        <div class="actions">
            <ng-container *windeHasAnyAuthority="userAuthorities.ALL_SIKLU">
                @if (project.nodesCount && project.engineType !== EngineProcessTypeEnum.BOM_CONFIGURATOR) {
                    <winde-ctx-sensitive-help [tooltipTextPath]="'projects.project.btn.download_project_files'" class="btn--edit">
                        <button (click)="exportProjectFilesArchive(project.id)" windeActionIcon>
                            <sui-svg-icon icon="download" windeOrange/>
                        </button>
                    </winde-ctx-sensitive-help>
                }
            </ng-container>

            @if (!project.bugReport &&
            project.engineType !== EngineProcessTypeEnum.RINGDES_V_1211 &&
            project.engineType !== EngineProcessTypeEnum.AREA_PLANNER) {
                <winde-ctx-sensitive-help
                        [tooltipTextPath]="
                        project.engineType === EngineProcessTypeEnum.BOM_CONFIGURATOR
                            ? 'projects.bom_config.btn.move'
                            : 'projects.project.btn.move'
                    "
                        class="btn--edit"
                >
                    <button
                            [routerLink]="['', { outlets: { popup: ['projects', project.id, 'move'] } }]"
                            queryParamsHandling="preserve"
                            windeActionIcon
                    >
                        <sui-svg-icon icon="share-square" windeOrange/>
                    </button>
                </winde-ctx-sensitive-help>
            }

            <winde-ctx-sensitive-help
                    [tooltipTextPath]="
                    project.engineType === EngineProcessTypeEnum.BOM_CONFIGURATOR
                        ? 'projects.bom_config.btn.edit'
                        : 'projects.project.btn.edit'
                "
                    class="btn--edit edit-project-button"
            >
                <button
                        [routerLink]="
                        project.engineType === EngineProcessTypeEnum.BOM_CONFIGURATOR
                            ? ['', { outlets: { popup: ['BOM', project.id, 'edit'] } }]
                            : ['', { outlets: { popup: ['projects', project.id, 'edit'] } }]
                    "
                        queryParamsHandling="preserve"
                        windeActionIcon
                >
                    <sui-svg-icon icon="pencil" windeOrange/>
                </button>
            </winde-ctx-sensitive-help>
            <winde-ctx-sensitive-help
                    [tooltipTextPath]="
                    project.engineType === EngineProcessTypeEnum.BOM_CONFIGURATOR
                        ? 'projects.bom_config.btn.remove'
                        : 'projects.project.btn.remove'
                "
                    class="btn--delete remove-project-button"
            >
                <button
                        [routerLink]="
                        project.engineType === EngineProcessTypeEnum.BOM_CONFIGURATOR
                            ? ['', { outlets: { popup: ['BOM', project.id, 'delete'] } }]
                            : ['', { outlets: { popup: ['projects', project.id, 'delete'] } }]
                    "
                        queryParamsHandling="preserve"
                        windeActionIcon
                >
                    <sui-svg-icon icon="cross" windeRed/>
                </button>
            </winde-ctx-sensitive-help>
        </div>
    </ng-container>

    @if (showInfo) {
        <div class="project-controls__info-popup">
            <p>
                <winde-highlight-text [text]="project.description || ''" [searchSubstring]="_searchFilter"></winde-highlight-text>
            </p>
            <div *windeHasAnyAuthority="userAuthorities.ALL_SIKLU">
                <p>
                    {{ 'project.firstDesignDate' | translate }}
                    <strong class="d-block">
                        <winde-date-format [date]="project.firstDesignDate" [showTimeAgo]="true"></winde-date-format>
                    </strong>
                </p>
                <p>
                    {{ 'project.firstBomExportSate' | translate }}
                    <strong class="d-block">
                        <winde-date-format [date]="project.firstBomDate" [showTimeAgo]="true"></winde-date-format>
                    </strong>
                </p>
            </div>
        </div>
    }
</div>
